// TestContent.js
import React from 'react';

const Financials = () => {
  return (
    <div>
      <h1>Financials</h1>
      <p>This content is coming from the TestContent component.</p>
    </div>
  );
};

export default Financials;